import { RequirePasswordReset } from '@core/models/require-password-reset.model';
import { RequireMfa, RequireMfaSetup } from '@core/models/require-mfa.model';
import { TokenObject } from '@core/models/token-object.model';

export type LoginResponse = TokenObject | RequirePasswordReset | RequireMfa | RequireMfaSetup;

export function isTokenObject(value: LoginResponse): value is TokenObject {
  return 'accessToken' in value;
}

export function isRequirePasswordReset(value: LoginResponse): value is RequirePasswordReset {
  return 'requirePasswordReset' in value;
}

export function isRequireMfa(value: LoginResponse): value is RequireMfa {
  return 'requireMfa' in value;
}

export function isRequireMfaSetup(value: LoginResponse): value is RequireMfaSetup {
  return 'requireMfaSetup' in value;
}
